import {
    RESET_PIPELINE_STATE,
    GET_PIPELINES_SUCCESS,
    GET_PIPELINES_FAILURE,
    GET_PIPELINE_BY_ID_SUCCESS,
    GET_PIPELINE_BY_ID_FAILURE,
    CREATE_PIPELINE_SUCCESS,
    CREATE_PIPELINE_FAILURE,
    UPDATE_PIPELINE_SUCCESS,
    UPDATE_PIPELINE_FAILURE,
    DELETE_PIPELINE_SUCCESS,
    DELETE_PIPELINE_FAILURE,
    RUN_PIPELINE_SUCCESS,
    RUN_PIPELINE_FAILURE,
    DRY_RUN_PIPELINE_REQUEST,
    DRY_RUN_PIPELINE_SUCCESS,
    DRY_RUN_PIPELINE_FAILURE,
} from "./actions";

const initialState = {
    getPipelinesResult: { success: true },
    pipelines: { Items: [] },
    getPipelineByIdResult: { success: true },
    currentPipeline: null,
    createPipelineResult: { success: true },
    updatePipelineResult: { success: true },
    deletePipelineResult: { success: true },
    runPipelineResult: { success: true },
    dryRunResult: null,
    dryRunLoading: false,
    dryRunError: null,
};

function reducer(state = initialState, action) {
    switch (action.type) {
        case RESET_PIPELINE_STATE:
            return {
                ...initialState,
                pipelines: state.pipelines,
            };
        case GET_PIPELINES_SUCCESS:
            return {
                ...state,
                getPipelinesResult: { success: true },
                pipelines: action.payload.result,
            };
        case GET_PIPELINES_FAILURE:
            return {
                ...state,
                getPipelinesResult: { success: false, error: action.payload.error },
            };
        case GET_PIPELINE_BY_ID_SUCCESS:
            return {
                ...state,
                getPipelineByIdResult: { success: true },
                currentPipeline: action.payload.pipeline,
            };
        case GET_PIPELINE_BY_ID_FAILURE:
            return {
                ...state,
                getPipelineByIdResult: { success: false, error: action.payload.error },
            };
        case CREATE_PIPELINE_SUCCESS:
            return {
                ...state,
                createPipelineResult: { success: true, pipeline: action.payload.pipeline },
            };
        case CREATE_PIPELINE_FAILURE:
            return {
                ...state,
                createPipelineResult: { success: false, error: action.payload.error },
            };
        case UPDATE_PIPELINE_SUCCESS:
            return {
                ...state,
                updatePipelineResult: { success: true, pipeline: action.payload.pipeline },
                currentPipeline: action.payload.pipeline,
            };
        case UPDATE_PIPELINE_FAILURE:
            return {
                ...state,
                updatePipelineResult: { success: false, error: action.payload.error },
            };
        case DELETE_PIPELINE_SUCCESS:
            return {
                ...state,
                deletePipelineResult: { success: true, deleted: true },
            };
        case DELETE_PIPELINE_FAILURE:
            return {
                ...state,
                deletePipelineResult: { success: false, error: action.payload.error },
            };
        case RUN_PIPELINE_SUCCESS:
            return {
                ...state,
                runPipelineResult: { success: true, result: action.payload.result },
            };
        case RUN_PIPELINE_FAILURE:
            return {
                ...state,
                runPipelineResult: { success: false, error: action.payload.error },
            };
        case DRY_RUN_PIPELINE_REQUEST:
            return {
                ...state,
                dryRunLoading: true,
                dryRunResult: null,
                dryRunError: null,
            };
        case DRY_RUN_PIPELINE_SUCCESS:
            return {
                ...state,
                dryRunLoading: false,
                dryRunResult: action.payload.result,
            };
        case DRY_RUN_PIPELINE_FAILURE:
            return {
                ...state,
                dryRunLoading: false,
                dryRunError: action.payload.error,
            };
        default:
            return state;
    }
}

export default reducer;
